import React, { useContext } from 'react';
import { LanguageContext } from '../LanguageContext';
import '../css/govuk-frontend.min.css';
import '../css/style.css';

function Cookies() {
  const { language } = useContext(LanguageContext);

  const text = {
    en: {
      title: "Cookies Policy",
      intro: "This site uses one essential cookie to keep your sign-in secure while you move through the Indigenous Skills and Employment Training (ISET) portal. We do not use cookies for advertising, analytics, profiling, or any other purpose.",
      whatAreCookies: "What are cookies?",
      whatAreCookiesContent: "Cookies are small text files stored on your device by websites to support features such as signing in or remembering your preferences.",
      howWeUseCookies: "How we use cookies",
      howWeUseCookiesContent: "When you sign in, we create an authentication cookie so the portal can keep your session active as you move between pages. The cookie contains an encrypted reference to your session and expires automatically when you sign out or after 12 hours of inactivity. We do not store personal details inside the cookie.",
      managingCookies: "Managing cookies",
      managingCookiesContent: "You can block or delete cookies in your browser settings. Blocking this authentication cookie will prevent sign-in from working, but the public parts of the site will remain available.",
      moreInfo: "More information",
      moreInfoContent: "For questions about cookies or privacy, use secure Messages after signing in or contact the NWAC ISET program team through the channels provided to you.",
      lastUpdated: "Last updated: March 16, 2026"
    },
    fr: {
      title: "Politique relative aux cookies",
      intro: "Ce site utilise un seul cookie essentiel pour maintenir votre connexion de façon sécurisée pendant que vous naviguez dans le portail ISET. Nous n'utilisons pas de cookies à des fins de publicité, d'analyse, de profilage ou à d'autres fins.",
      whatAreCookies: "Qu’est-ce qu’un cookie?",
      whatAreCookiesContent: "Les cookies sont de petits fichiers texte stockés sur votre appareil par les sites Web afin de permettre certaines fonctions, notamment la connexion ou la conservation de vos préférences.",
      howWeUseCookies: "Notre utilisation des cookies",
      howWeUseCookiesContent: "Lorsque vous ouvrez une session, nous créons un cookie d’authentification afin que le portail puisse maintenir votre session active lorsque vous passez d’une page à l’autre. Ce cookie contient une référence chiffrée à votre session et expire automatiquement lorsque vous fermez la session ou après 12 heures d’inactivité. Aucun renseignement personnel n’est stocké dans le cookie.",
      managingCookies: "Gérer les cookies",
      managingCookiesContent: "Vous pouvez bloquer ou supprimer les cookies dans les paramètres de votre navigateur. Si vous bloquez ce cookie d’authentification, la connexion ne fonctionnera pas, mais les sections publiques du site demeureront accessibles.",
      moreInfo: "Pour en savoir plus",
      moreInfoContent: "Pour toute question concernant les cookies ou la confidentialité, utilisez les Messages sécurisés après l'ouverture de session ou communiquez avec l'équipe du programme ISET de l'AFAC par les voies qui vous ont été fournies.",
      lastUpdated: "Dernière mise à jour : 16 mars 2026"
    }
  };  

  return (
    <div>
      <main className="govuk-main-wrapper govuk-width-container" role="main">
        <h1 className="govuk-heading-l">{text[language].title}</h1>
        <p className="govuk-body">
          {text[language].intro}
        </p>

        <section className="govuk-section-break govuk-section-break--xl govuk-section-break--visible">
          <h2 className="govuk-heading-m">{text[language].whatAreCookies}</h2>
          <p className="govuk-body">
            {text[language].whatAreCookiesContent}
          </p>
        </section>

        <section className="govuk-section-break govuk-section-break--xl govuk-section-break--visible">
          <h2 className="govuk-heading-m">{text[language].howWeUseCookies}</h2>
          <p className="govuk-body">
            {text[language].howWeUseCookiesContent}
          </p>
        </section>

       <section className="govuk-section-break govuk-section-break--xl govuk-section-break--visible">
         <h2 className="govuk-heading-m">{text[language].managingCookies}</h2>
         <p className="govuk-body">
           {text[language].managingCookiesContent}
         </p>
       </section>

        <section className="govuk-section-break govuk-section-break--xl govuk-section-break--visible">
          <h2 className="govuk-heading-m">{text[language].moreInfo}</h2>
          <p className="govuk-body">
            {text[language].moreInfoContent}
          </p>
        </section>

        <p className="govuk-body">
          {text[language].lastUpdated}
        </p>
      </main>
    </div>
  );
}

export default Cookies;

